import { Table } from '@octano/global-ui';
import TableEmptyContent from '../../../../components/text/TableEmptyContent';
import {
  StudentsRiskHistoryLoaderData,
  StudentsRiskHistoryLoader,
} from './hooks/StudentsRiskHistoryLoader';
import { useColumns } from './hooks/useColumns';
import { useTexts } from './hooks/useTexts';

export function StudentsListTable() {
  const { data, total_pages, total } = StudentsRiskHistoryLoaderData();
  const { query, updateQuery } = StudentsRiskHistoryLoader();
  const columns = useColumns();
  const texts = useTexts().table;

  return (
    <Table
      columns={columns}
      data={data}
      striped
      noResultsText={
        <TableEmptyContent
          title={texts.noRecords}
          subtitle={texts.noRecordsSubtitle}
        />
      }
      pagination={{
        currentPage: query.page + 1,
        totalItems: total,
        totalPages: total_pages,
        itemsPerPage: query.items_per_page,
        onChangePage: (page) => updateQuery({ ...query, page: page - 1 }),
      }}
    />
  );
}
